import request from '@/utils/request'
import store from '@/store'
import axios from 'axios'
const url = store.getters.getPostUrl;
export default {
	getEquipmentFirm(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentFirm/page',
			method: 'post',
			data: param
		})
	},
  getByDictIdALL(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/dict/ByDictIdALL',
      method: 'get',
      params: param
    })
  },
	// getFactoryTypeList() {
	// 	return request({
	// 		url: store.getters.getPostUrl + 'mes/dict/ByDictIdALL?dictId=1',
	// 		method: 'get'
	// 	})
	// },
	// getUnitList() {cheng
	// 	return request({
	// 		url: store.getters.getPostUrl + 'mes/dict/ByDictIdALL?dictId=4',
	// 		method: 'get'
	// 	})
	// },
	getCheckList() {
		return request({
			url: store.getters.getPostUrl + 'mes/dict/ByDictIdALL?dictId=2',
			method: 'get'
		})
	},
	// getPartsList() {
	// 	return request({
	// 		url: store.getters.getPostUrl + 'mes/dict/ByDictIdALL?dictId=3',
	// 		method: 'get'
	// 	})
	// },
	// getTxtTypeList() {
	// 	return request({
	// 		url: store.getters.getPostUrl + 'mes/dict/ByDictIdALL?dictId=5',
	// 		method: 'get'
	// 	})
	// },
	// getRiskList() {
	// 	return request({
	// 		url: store.getters.getPostUrl + 'mes/dict/ByDictIdALL?dictId=7',
	// 		method: 'get'
	// 	})
	// },
	saveEquipmentFirmInsert(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentFirm/insert',
			method: 'post',
			data: param
		})
	},
	saveEquipmentTypeCheckInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeCheckInfo/insert',
			method: 'post',
			data: param
		})
	},
	saveEquipmentCheckInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentCheckInfo/insert',
			method: 'post',
			data: param
		})
	},
	saveEquipmentTypeInspectionInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeInspectionInfo/insert',
			method: 'post',
			data: param
		})
	},
	saveEquipmentInspectionInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInspectionInfo/insert',
			method: 'post',
			data: param
		})
	},
	saveEquipmentFirmUpdate(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentFirm/update',
			method: 'post',
			data: param
		})
	},
	exportEquipmentFirm(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentFirm/export',
			method: 'post',
			data: param
		})
	},
	delEquipmentFirm(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentFirm/delete?id=' + param,
			method: 'get',
		})
	},
	saveEquipmentFirmSelectById(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentFirm/selectById?id=' + param.id + '&Language=' + param.Language,
			method: 'get',
		})
	},
	getEquipmentTypeList(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentType/list?pid=' + param,
			method: 'post'
		})
	},
	getEquipmentInfoList(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInfo/tree',
			method: 'post',
			data: param
		})
	},
	getEquipmentInfoList1(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/baseCustomer/tree',
			method: 'post',
			data: param
		})
	},
	getEquipmentInfoPageList(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInfo/page',
			method: 'post',
			data: param
		})
	},
	getEquipmentInfoPageStatusList(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInfo/info',
			method: 'post',
			data: param
		})
	},
	getEquipmentTypeParameterList(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeParameter/page',
			method: 'post',
			data: param

		})
	},
	saveEquipmentTypeParameter(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeParameter',
			method: 'post',
			data: param
		})
	},
	saveEquipmentTypeDocument(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeDocument',
			method: 'post',
			data: param
		})
	},
	saveEquipmentDocument(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentDocument',
			method: 'post',
			data: param
		})
	},
	saveEquipmentTypeMaintainInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeMaintainInfo',
			method: 'post',
			data: param
		})
	},
	saveEquipmentMaintainInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainInfo',
			method: 'post',
			data: param
		})
	},
	delEquipmentTypeParameter(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeParameter?id=' + param,
			method: 'delete',
		})
	},
	delEquipmentTypeDocument(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeDocument?id=' + param,
			method: 'delete',
		})
	},
	delEquipmentDocument(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentDocument?id=' + param,
			method: 'delete',
		})
	},
	delEquipmentTypeMaintainInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeMaintainInfo?id=' + param,
			method: 'delete',
		})
	},
	delEquipmentMaintainInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainInfo?id=' + param,
			method: 'delete',
		})
	},
	delEquipmentTypeCheckInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeCheckInfo/delete?id=' + param,
			method: 'delete',
		})
	},
	delEquipmentCheckInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentCheckInfo/delete?id=' + param,
			method: 'delete',
		})
	},
	delEquipmentTypeInspectionInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeInspectionInfo/delete?id=' + param,
			method: 'delete',
		})
	},
	delEquipmentInspectionInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInspectionInfo/delete?id=' + param,
			method: 'delete',
		})
	},
	selectCard(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInfo/card',
			method: 'post',
			params: {
				'id': param
			}
		})
	},
	getEquipmentTypeParameterMes(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeParameter/all?id=' + param,
			method: 'post',
		})
	},
	getEquipmentTypeDocumentMes(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeDocument/all?id=' + param,
			method: 'post',
		})
	},
	getEquipmentDocumentMes(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentDocument/all',
			method: 'post',
			params: {
				'id': param
			}
		})
	},
	getEquipmentTypeMaintainInfoMes(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeMaintainInfo/all?id=' + param,
			method: 'post',
		})
	},
	getEquipmentMaintainInfoMes(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainInfo/all?id=' + param,
			method: 'post',
		})
	},
	getEquipmentTypeCheckInfoMes(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeCheckInfo/selectById?id=' + param,
			method: 'get',
		})
	},
	getEquipmentCheckInfoMes(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentCheckInfo/selectById?id=' + param,
			method: 'get',
		})
	},
	getEquipmentTypeInspectionInfoMes(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeInspectionInfo/selectById?id=' + param,
			method: 'get',
		})
	},
	getEquipmentInspectionInfoMes(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInspectionInfo/selectById?id=' + param,
			method: 'get',
		})
	},
	saveEquipmentTypeParameterEdit(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeParameter',
			method: 'put',
			data: param
		})
	},
	saveEquipmentTypeDocumentEdit(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeDocument',
			method: 'put',
			data: param
		})
	},
	saveEquipmentTypeEdit(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentType',
			method: 'put',
			data: param
		})
	},
	saveEquipmentDocumentEdit(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentDocument',
			method: 'put',
			data: param
		})
	},
	saveEquipmentTypeMaintainInfoEdit(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeMaintainInfo',
			method: 'put',
			data: param
		})
	},
	saveEquipmentMaintainInfoEdit(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainInfo',
			method: 'put',
			data: param
		})
	},
	saveEquipmentTypeCheckInfoEdit(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeCheckInfo/update',
			method: 'put',
			data: param
		})
	},
	saveEquipmentCheckInfoEdit(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentCheckInfo/update',
			method: 'put',
			data: param
		})
	},
	saveEquipmentCheckInfoEdits(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentCheckInfo/updates',
			method: 'put',
			data: param
		})
	},
	saveEquipmentTypeInspectionInfoEdit(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeInspectionInfo/update',
			method: 'put',
			data: param
		})
	},
	saveEquipmentInspectionInfoEdit(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInspectionInfo/update',
			method: 'put',
			data: param
		})
	},
	sortEquipmentTypeCheckInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeCheckInfo/sort',
			method: 'post',
			params: param
		})
	},
	sortEquipmentTypeCheckInfo2(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeCheckInfo/sort2',
			method: 'post',
			params: param
		})
	},
	sortEquipmentInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInfo/sort',
			method: 'post',
			params: param
		})
	},
	sortEquipmentCheckInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentCheckInfo/sort',
			method: 'post',
			params: param
		})
	},
	sortEquipmentCheckInfo2(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentCheckInfo/sort2',
			method: 'post',
			params: param
		})
	},
	confirmEquipmentType(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentType/confirm',
			method: 'post',
			params: param
		})
	},
	sortEquipmentTypeInspectionInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeInspectionInfo/sort',
			method: 'post',
			params: param
		})
	},
	sortEquipmentTypeInspectionInfo2(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeInspectionInfo/sort2',
			method: 'post',
			params: param
		})
	},
	sortEquipmentInspectionInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInspectionInfo/sort',
			method: 'post',
			params: param
		})
	},
	sortEquipmentInspectionInfo2(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInspectionInfo/sort2',
			method: 'post',
			params: param
		})
	},
	sortEquipmentTypeMaintainInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeMaintainInfo/sort',
			method: 'post',
			params: param
		})
	},
	sortEquipmentTypeMaintainInfo2(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeMaintainInfo/sort2',
			method: 'post',
			params: param
		})
	},
	sortEquipmentMaintainInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainInfo/sort',
			method: 'post',
			params: param
		})
	},
	sortEquipmentMaintainInfo2(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainInfo/sort2',
			method: 'post',
			params: param
		})
	},
	getEquipmentTypeCheckInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeCheckInfo/page',
			method: 'post',
			data: param
		})
	},
	getEquipmentTypeInspectionInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeInspectionInfo/page',
			method: 'post',
			data: param
		})
	},
	getEquipmentParameter(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentParameter/all',
			method: 'post',
			params: {
				'equipmentId': param
			}
		})
	},
	getEquipmentCheckInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentCheckInfo/page',
			method: 'post',
			data: param
		})
	},
	getEquipmentMaintainInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainInfo/page',
			method: 'post',
			data: param
		})
	},
	getEquipmentMaintainInfo1(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainInfo/page2',
			method: 'post',
			data: param
		})
	},
	getEquipmentTypeMaintainInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeMaintainInfo/page',
			method: 'post',
			data: param
		})
	},
	getEquipmentInspectionInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInspectionInfo/page',
			method: 'post',
			data: param
		})
	},
	getEquipmentDocumentInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentDocument/page',
			method: 'post',
			data: param
		})
	},
	getEquipmentDocumentInfo1(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentDocument/page2',
			method: 'post',
			data: param
		})
	},
	getEquipmentTypeDocumentInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeDocument/page',
			method: 'post',
			data: param
		})
	},
	getEquipmentTypePartInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypePart/page',
			method: 'post',
			data: param
		})
	},
	getEquipmentPartInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentPart/page',
			method: 'post',
			data: param
		})
	},
	getEquipmentPartInfo1(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentPart/page2',
			method: 'post',
			data: param
		})
	},
	upload(data) {
		return request({
			config: {
				'Content-Type': 'multipart/form-data',
			},
			url: store.getters.getPostUrl + '/mes/sysFile/uploadFolder',
			method: "post",
			data: data
		})
	},
	confirmPartInfo(param) {
		return request({
			url: store.getters.getPostUrl + '/mes/equipmentTypePart/insert',
			method: "post",
			data: param
		})
	},
	confirmPart(param) {
		return request({
			url: store.getters.getPostUrl + '/mes/equipmentPart/insert',
			method: "post",
			data: param
		})
	},
	delEquipmentTypePartInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypePart/delete',
			method: 'delete',
			params: {
				'id': param
			}
		})
	},
	delEquipmentPartInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentPart/delete',
			method: 'delete',
			params: {
				'id': param
			}
		})
	},
	confirmEquipmentInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInfo/confirm',
			method: 'post',
			params: {
				'id': param
			}
		})
	},
	getEquipmentParts(param) {
		return request({
			url: store.getters.getPostUrl + '/mes/equipmentParts/all',
			method: "post",
			data: param
		})
	},
	// 分仓库查询全部备件
	getEquipmentPartsall(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentParts/stock/all',
			method: "post",
			data: param
		})
	},
	updateEquipmentInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInfo',
			method: 'put',
			data: param
		})
	},
	selectEquipmentFirmList(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentFirm/like',
			method: 'post',
			params: param
		})
	},
	selectEquipmentCheckPageAll(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentCheck/pageAll',
			method: 'post',
			data: param
		})
	},
	selectEquipmentCheckCount() {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentCheck/COUNT',
			method: 'post'
		})
	},
	selectEquipmentAreaPageAll(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentCheckPlan/page',
			method: 'post',
			data: param
		})
	},
	selectUserRisk(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/baseSkill/page',
			method: 'post',
			data: param
		})
	},
	selectEquipmentCheckStartORstop(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentCheck/startORstop',
			method: 'post',
			data: param
		})
	},
	selectDeptListByName(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/sysDept/listByName',
			method: 'post',
			params: param
		})
	},
	selectDeptListByName2(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/sysDept/listByName2',
			method: 'post',
			params: param
		})
	},
	selectTypeListByName(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentType/typeNamelist',
			method: 'post',
			params: param
		})
	},
	selectTypeListByName2(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentType/typeNamelist2',
			method: 'post',
			params: param
		})
	},
	saveEquipmentParameter(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentParameter',
			method: 'post',
			data: param
		})
	},
	updateEquipmentCheckPlan(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentCheckPlan/update',
			method: 'put',
			data: param
		})
	},
	saveMaintainRest(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentCheckRest/update',
			method: 'post',
			data: param
		})
	},
	getRiskContent(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/baseRisk/page?deviceId=' + param.deviceId + '&type=' + param.type + '&id=' + param.id,
			method: 'post',
			data: param
		})
	},
	addRisk(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/baseRisk/insert',
			method: 'post',
			data: param
		})
	},
	editRisk(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/baseRisk/update',
			method: 'put',
			data: param
		})
	},
	delRisk(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/baseRisk/delete',
			method: 'delete',
			params: param
		})
	},
	selectWarningTime(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/baseWarningTime/select',
			method: 'post',
			params: param
		})
	},
	updateWarningTime(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/baseWarningTime/update',
			method: 'post',
			data: param
		})
	},
	selectFileType(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/sysFile/type',
			method: 'post',
			params: {
				'id': param
			}
		})
	},
	selectFileName(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/sysFile/name',
			method: 'post',
			params: {
				'id': param
			}
		})
	},
	selectWarningUser(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/baseWarningTime/selectUser',
			method: 'post',
			data: param
		})
	},
	selectEquipmentCheckPlanCount(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentCheckPlan/count',
			method: 'post',
			params: param
		})
	},
	selectRest(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentCheckRest/selectById',
			method: 'post',
			data: param
		})
	},
	findPids(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInfo/findPids',
			method: 'post',
			params: param
		})
	},
	selectDeptName(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInfo/dept?id=' + param,
			method: 'post',
		})
	},
	selectDeptIdList(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInfo/deptId?id=' + param,
			method: 'post',
		})
	},
	selectEquipmentaintainRest(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentaintainRest/selectById',
			method: 'post',
			data: param
		})
	},
	stop(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentCheckPlan/useORStop',
			method: 'put',
			params: param
		})
	},
	saveAcquiescenceRest(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentCheckRest/acquiescence',
			method: 'post',
			params: param
		})
	},
	// 分页查询备件信息
	getPartsinformation(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentParts/page',
			method: 'post',
			data: param
		})
	},
	// 仓库管理 仓库下拉选
	getWarehousedown(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/warehouse',
			method: 'get',
		})
	},
	// 备件信息 备件入库
	getEquipmentPartsin(param) {
		return request({
			url: store.getters.getPostUrl + '/mes/equipmentParts/in',
			method: 'post',
			data: param
		})
	},
	// 备件信息 备件出库
	getEquipmentPartsout(param) {
		return request({
			url: store.getters.getPostUrl + '/mes/equipmentParts/out',
			method: 'post',
			data: param
		})
	},
	// 入出库记录分页查询
	getinoutselect(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentParts/record',
			method: 'post',
			data: param
		})
	},
	// 备件信息 单位下拉选
	// getUnitdown(param) {
	// 	return request({
	// 		url: store.getters.getPostUrl + 'mes/dict/ByDictIdALL?dictId=' + param,
	// 		method: 'get',
	// 	})
	// },
	//备件信息  分类下选
	// getTypedown(param) {
	// 	return request({
	// 		url: store.getters.getPostUrl + 'mes/dict/ByDictIdALL?dictId=' + param,
	// 		method: 'get',
	// 	})
	// },
	//备件信息  数据删除
	delEquipmentParts(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentParts/?id=' + param,
			method: 'delete',
			data: param
		})
	},
	//备件信息  新增数据
	saveEquipmentPartsInsert(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentParts',
			method: 'post',
			data: param
		})
	},
	//备件信息 编辑数据（根据id查询）
	saveEquipmentPartsInfoByid(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentParts/' + param,
			method: 'get',
		})
	},
	//备件信息 修改数据
	ModifyEquipmentParts(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentParts',
			method: 'put',
			data: param
		})
	},
	//备件信息  导出信息
	exportEquipmentParts(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentParts/all',
			method: 'post',
			data: param
		})
	},
	// 分页查询备件库存
	getstockpage(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentParts/stock/page',
			method: 'post',
			data: param
		})
	},
	// 查询备件库存明细
	getstockDetailpage(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentParts/stockDetail',
			method: 'post',
			data: param
		})
	},
	// 新增盘点任务
	getinventorytask(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentParts/inventory/task',
			method: 'post',
			data: param
		})
	},
	// 盘点任务分页查询
	getinventorytaskpage(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentParts/inventory/task/page',
			method: 'post',
			data: param
		})
	},
	// 删除盘点任务
	equipmentInspectionInfo(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentParts/inventory/task?id=' + param,
			method: 'delete',
		})
	},
	// 盘点任务作废
	Inventoryvoid(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentParts/inventory/cancel?id=' + param,
			method: 'post',
			data: param
		})
	},
	// 盘点任务明细查询
	taskQuery(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentParts/inventory/detail/' + param,
			method: 'get',
			data: param
		})
	},
	// 盘点任务暂存
	Inventorytaskstaging(param, e) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentParts/inventory/cache/' + param,
			method: 'post',
			data: e
		})
	},
	// 盘点任务提交
	Inventorytsubmit(param, e) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentParts/inventory/submit/' + param,
			method: 'post',
			data: e
		})
	},
	//查询作业风险
	selectRisk(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/baseRisk/selectRisk/',
			method: 'post',
			params: param
		})
	},
	// 库位管理分页查询
	equipmentParts(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/warehouse/page',
			method: 'post',
			data: param
		})
	},
	// 库位管理新增
	warehouse(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/warehouse',
			method: 'post',
			data: param
		})
	},
	// 库位管理删除
	delWarehouse(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/warehouse?id=' + param,
			method: 'delete',
		})
	},
	// 库位管理 编辑[ID]
	equipmentPartsDetail(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/warehouse/' + param,
			method: 'get',
			data: param
		})
	},
	// 库位管理 编辑
	equipmentPartsPut(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/warehouse/',
			method: 'put',
			data: param
		})
	},
	// 仪表盘list
	equipmentMonitoringService(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMonitoringService/selectEquipmentById',
			method: 'post',
			data: param
		})
	},
	// 月
	KPIselectList(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/KPI/selectList',
			method: 'post',
			data: param
		})
	},
	// 日
	KPIselectListDay(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/KPI/selectListDay',
			method: 'post',
			data: param
		})
	},
	// 查询时间
	selectTimee(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMonitoringService/selectTime',
			method: 'get',
			data: param
		})
	},
	selectTreeList(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairKnowledge/tree',
			method: 'post',
			params: param
		})
	},
	getDictList(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/dict/ByDictIdALL?dictId=' + param,
			method: 'get'
		})
	},
	getDictList1(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/dict/ByDictIdALL1?pid=' + param,
			method: 'get'
		})
	},
	getDictList2(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/dict/ByDictIdALL2',
			method: 'get',
      params: param
		})
	},
	// 稼动分析接口
	selectActivation(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/KPI/selectActivation',
			method: 'post',
			data: param
		})
	},
	selectUser(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/user/userName?fullName=' + param,
			method: 'post',
		})
	},
	repairTaskNum(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/user/selectRepairNum?fullName=' + param,
			method: 'post',
		})
	},
	selectDept(param) {
		return request({
			url: store.getters.getPostUrl + 'organization/organizationName',
			method: 'post',
			params: param
		})
	},
	selectByName(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInfo/byName?name=' + param,
			method: 'post',
		})
	},
	riskRecord(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/riskRecord',
			method: 'post',
			params: {
				'taskId': param
			}
		})
	},
	riskRecord1(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/riskRecord1',
			method: 'post',
			params: {
				'taskId': param
			}
		})
	},
	mriskRecord1(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainRecord/riskRecord1',
			method: 'post',
			params: {
				'taskId': param
			}
		})
	},
	maintainRecord(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainRecord/riskRecord',
			method: 'post',
			params: {
				'taskId': param
			}
		})
	},
	getEquipmentTypePosition(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypePosition/page',
			method: 'post',
			data: param
		})
	},
	getEquipmentTypePositionMes(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypePosition/selectById?id=' + param,
			method: 'get',
		})
	},
	saveEquipmentTypePosition(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypePosition',
			method: 'post',
			data: param
		})
	},
	saveEquipmentTypePositionEdit(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypePosition',
			method: 'put',
			data: param
		})
	},
	delEquipmentTypePosition(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypePosition?id=' + param,
			method: 'delete',
		})
	},
	getEquipmentPosition(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentPosition/page',
			method: 'post',
			data: param
		})
	},
	getEquipmentPositionMes(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentPosition/selectById?id=' + param,
			method: 'get',
		})
	},
	saveEquipmentPosition(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentPosition',
			method: 'post',
			data: param
		})
	},
	saveEquipmentPositionEdit(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentPosition',
			method: 'put',
			data: param
		})
	},
	delEquipmentPosition(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentPosition?id=' + param,
			method: 'delete',
		})
	},
	getTypePositionList(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypePosition/all',
			method: 'post',
			data: {
				'equipmentTypeId': param
			}
		})
	},
	getPositionList(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentPosition/all',
			method: 'post',
			data: {
				'equipmentTypeId': param
			}
		})
	},

	importExcel(data) {
		return request({
			config: {
				'Content-Type': 'multipart/form-data',
			},
			url: store.getters.getPostUrl + 'mes/equipmentInfo/upload',
			method: "post",
			data: data
		})
	},
	progress() {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInfo/progress',
			method: 'post',
		})
	},
	delectProgress() {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInfo/clearProgress',
			method: 'post',
		})
	},
	selectCustomerList(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/baseCustomer/page',
			method: 'post',
			data: param
		})
	},
	selectCustomerById(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/baseCustomer/' + param,
			method: 'get',
			data: param
		})
	},
	addCustomer(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/baseCustomer',
			method: 'post',
			data: param
		})
	},
	updateCustomer(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/baseCustomer/',
			method: 'put',
			data: param
		})
	},
	delCustomer(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/baseCustomer?id=' + param,
			method: 'delete',
		})
	},
  importPartsExcel(data) {
    return request({
      config: {
        'Content-Type': 'multipart/form-data',
      },
      url: store.getters.getPostUrl + 'mes/equipmentParts/upload',
      method: "post",
      data: data
    })
  },
  partsProgress() {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentParts/progress',
      method: 'post',
    })
  },
  partsDelectProgress() {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentParts/clearProgress',
      method: 'post',
    })
  },
  resetPlanStatus(params) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckPlan/resetPlanStatus',
      method: 'post',
      data: params
    })
  },
  resetTypePlanStatus(params) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckPlan/resetTypePlanStatus',
      method: 'post',
      data: params
    })
  },
  resetOrgPlanStatus(params) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckPlan/resetOrgPlanStatus',
      method: 'post',
      data: params
    })
  },
  getOrgTreeNodeByOrgId(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentInfo/getOrgTreeNodeByOrgId',
      method: 'get',
      params: param
    })
  },
  getTypeTreeNodeByTypeId(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentInfo/getTypeTreeNodeByTypeId',
      method: 'get',
      params: param
    })
  },
  typeCheckInfoExportExcel(params) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentTypeCheckInfo/typeCheckInfoExportExcel',
      method: 'post',
      data: params,
      responseType: 'blob'
    })
  },
  checkInfoExportExcel(params) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckInfo/checkInfoExportExcel',
      method: 'post',
      data: params,
      responseType: 'blob'
    })
  },
  checkPlanExportExcel(params) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckPlan/checkPlanExportExcel',
      method: 'post',
      data: params,
      responseType: 'blob'
    })
  },
  selectEmail(params) {
    return request({
      url: store.getters.getPostUrl + 'mes/electricalMail',
      method: 'get',
      params: {'hierarchy': params}
    })
  },
  updateEmail(params) {
    return request({
      url: store.getters.getPostUrl + 'mes/electricalMail',
      method: 'put',
      data: params
    })
  },
  getManufacturerList() {
    return request({
      url: store.getters.getPostUrl + '/mes/equipmentFirm/selectAll',
      method: 'get'
    })
  },
  getOutsourcingList() {
    return request({
      url: store.getters.getPostUrl + '/mes/equipmentFirm/selectAll',
      method: 'get'
    })
  },
  	getCheckEmailList(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/dict/emailByDictIdALL',
			method: 'get',
			params: param
		})
	},
	// 新增接口  同步日历
	syncReginoalRest(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentCheckRest/syncReginoalRest',
			method: 'post',
			data: param
		})
	},
}



// WEBPACK FOOTER //
// ./src/assets/js/file/file.js